import { BASE_URL } from "@funded-here-interface/common/src/constant/constant";
import axios from "axios";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";

type GetDocumentRequest = {
  fileName: string;
};

const getFhDocument = async ({ fileName }: GetDocumentRequest) => {
  try {
    const response = await axios.get(
      `${BASE_URL}/trade-directory/upload/fh-document/${fileName}`,
      {
        headers: {
          "Content-Type": "application/json",
        },
        responseType: "blob",
        withCredentials: true,
      }
    );

    return response.data;
  } catch (e) {
    const message = getApiResponseErrorMsg(e);

    throw new Error(message);
  }
};

export default getFhDocument;
